export default "__VITE_ASSET__C8s4YKdX__"